import { createFileRoute } from "@tanstack/react-router";
import { QuickStart } from "@/routes/help/quick-start";

export const Route = createFileRoute("/dashboard/help/quick-start")({
	component: QuickStart,
});
